import axios from 'axios';
import {PRICE_VERSION_VARIATION_VERSION_ENDPOINT} from '../../endpoints';

export async function getAllVersions({search}){
  try{
    let data = await axios.get(`${PRICE_VERSION_VARIATION_VERSION_ENDPOINT}/${search}`).then(result=>result.data);
    return data
  }catch(error){
    throw new Error(error)
  }
}